<div>
  <h1>Dashboard</h1>

  <div
    class="widgets-container"
    cdkDropList
    [cdkDropListData]="widgetsToShow"
    (cdkDropListDropped)="drop($event)"
  >
    <div
      class="widget"
      *ngFor="let widget of widgetsToShow"
      cdkDrag
    >
      <ng-container *ngIf="widget.component === 'Widget1Component'">
        <app-tasktrackerchart></app-tasktrackerchart>
      </ng-container>
      <ng-container *ngIf="widget.component === 'Widget2Component'">
        <app-durationchart></app-durationchart>
      </ng-container>
      <ng-container *ngIf="widget.component === 'Widget3Component'">
        <app-statuschart></app-statuschart>
      </ng-container>
    </div>
  </div>
</div>

<!-- 
<div class="container-fluid top-nav">
    <div class="row pt-3">
        <div class="col-md-12 col-lg-6 col-xl-6 col-12">
            <app-tasktrackerchart></app-tasktrackerchart>
        </div>
        <div class="col-md-12 col-lg-6 col-xl-3 col-12">
            <div style="position: absolute; top:30px; right:20px; z-index: 2;">
                <span data-toggle="modal" data-target="#durationmodal" class="material-icons bg-secondary" style="font-size: 16px; padding:2px; border-radius: 50%; border: 1px solid #ccc;">
                    filter_alt
                    </span>
            </div>
            <div class="card collapse" id="durationCollapse" style="position: absolute; top:25px; left:15px; z-index: 1; background-color: #ccc; opacity: 0.8; height:320px; width:92%;">
            </div>
            <app-durationchart></app-durationchart>
        </div>
            <div [@inbgOutAnimation] class="col-md-12 col-lg-12 col-xl-3 col-12">
                <app-statuschart></app-statuschart>
            </div>
        <!-- <ng-container  >
            <div [@inbgOutAnimation] class="col-md-3 col-12">
                <app-durationselect></app-durationselect>
            </div>
        </ng-container>

    </div>
    <app-compactprojectlist></app-compactprojectlist>
</div>

   -->
  <!-- Modal -->
<!--    
  <div class="modal fade" id="durationmodal" tabindex="-1" role="dialog" aria-labelledby="durationmodal" >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Duration by template</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <app-durationselect></app-durationselect>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-close" data-dismiss="modal"><p class="btn-save-text">Close</p></button>
          <button type="button" class="btn-save"><p class="btn-save-text">Save changes</p></button>
        </div>
      </div>
    </div>
  </div> -->